import { render, staticRenderFns } from "./UnderlineButton.vue?vue&type=template&id=51ca840e&"
import script from "./UnderlineButton.vue?vue&type=script&lang=ts&"
export * from "./UnderlineButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports